@if ((auth.isAuthenticated$ | async) === true) {
    <div>
        <ion-buttons>
            <ion-button [color]="color" (click)="loginService.tryUserInitiatedLogout()" slot="end">
                <ion-icon name="log-out-outline" slot="start"></ion-icon>
                log out
            </ion-button>
        </ion-buttons>
    </div>
} @else {
    <ion-button (click)="loginService.login()">
        sign in / register
    </ion-button>
}
